import { render } from "./neuvo-icon-mic.svg?vue&type=template&id=246338d8"
const script = {}
script.render = render

export default script